import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-immediate-input',
	templateUrl: './immediate-input.component.html',
	styleUrls: ['./immediate-input.component.scss'],
	imports: [IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImmediateInputComponent implements AfterViewInit, OnDestroy {
	@Input()
	init!: string;

	@Output()
	done = new EventEmitter<string | undefined>();

	@ViewChild('element')
	ref?: ElementRef;

	@ViewChild('cancelIcon', { read: ElementRef })
	cancelIconRef?: ElementRef<HTMLElement>;

	// Een mousedown/touchstart op het sluiten-icoon blurt de input vóórdat Angular's eigen
	// (mousedown)-binding op dat icoon kan draaien — preventDefault() daar komt te laat om de
	// resulterende (focusout) te stoppen. Deze vlag wordt daarom in de capture-fase gezet, zodat
	// hij synchroon vóór die focusout binnenkomt, ongeacht de exacte volgorde die de browser hier
	// intern aanhoudt.
	private cancelling = false;
	private readonly onCancelIconDown = () => {
		this.cancelling = true;
	};

	ngAfterViewInit() {
		const element = this.ref!.nativeElement;
		element.select();
		element.focus();

		const cancelIcon = this.cancelIconRef!.nativeElement;
		cancelIcon.addEventListener('mousedown', this.onCancelIconDown, { capture: true });
		cancelIcon.addEventListener('touchstart', this.onCancelIconDown, { capture: true });
	}

	ngOnDestroy() {
		const cancelIcon = this.cancelIconRef?.nativeElement;
		cancelIcon?.removeEventListener('mousedown', this.onCancelIconDown, { capture: true });
		cancelIcon?.removeEventListener('touchstart', this.onCancelIconDown, { capture: true });
	}

	submit(event: Event, result: string | undefined) {
		if (this.cancelling) return;
		this.done.emit(result);
	}

	cancel() {
		this.cancelling = false;
		this.done.emit(undefined);
	}
}
